var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-y grid grid-cols-12 gap-6"},[_c('div',{staticClass:"col-span-12 lg:col-span-8"},[_c('OfficerPerformance',{attrs:{"officer":_vm.officer}})],1),_c('div',{staticClass:"col-span-12 lg:col-span-4"},[_c('OfficerNotesWithDeadLine',{attrs:{"officer":_vm.officer,"title":_vm.$t('text.haveDeadline')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }